module.exports = __webpack_public_path__ + "img/tjt_tbt777_1993.prt.ac67586b.jpg";